<div class="document-highlighter-container" [class.manual-highlight-enabled]="allowManualHighlighting"> <!-- ADDED class binding -->

  <!-- Display content only if segments are processed -->
  <div *ngIf="processedSegments.length > 0; else noContent" class="content-display">
    <!-- Use <pre> for preserving whitespace and line breaks from textContent -->
    <pre class="highlighted-content"><span
      *ngFor="let segment of processedSegments"
      [ngClass]="getSegmentClasses(segment)"
      [title]="segment.isHighlighted
                ? (segment.highlightInfo?.tooltip || segment.highlightInfo?.textToFind + ' (Ctrl+Click to remove)')
                : (allowManualHighlighting ? 'Select text to create highlight' : null)"
      (click)="onSegmentClick(segment, $event)"
    >{{ segment.text }}</span></pre>
  </div>

  <!-- Template shown when no segments (e.g., no textContent) -->
  <ng-template #noContent>
    <div class="no-content-message">
      <p *ngIf="!textContent">No document content provided.</p>
      <p *ngIf="textContent">Processing content...</p> <!-- Or a loading indicator -->
    </div>
  </ng-template>

</div>
